import { render, staticRenderFns } from "./FormVrf.vue?vue&type=template&id=0538bc06&"
import script from "./FormVrf.vue?vue&type=script&lang=js&"
export * from "./FormVrf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports